import axios from 'axios';
import {
  KioskApi,
  OnlineOrder,
  KioskOrderingStore,
  Station,
  ResultResponse
} from 'kiolyn-api';
import IKioskOrderingRepository from '../domain/repositories/IKioskOrderingRepository';

export class KioskOrderingRepository implements IKioskOrderingRepository {
  private readonly api: KioskApi;

  constructor(basePath: string) {
    this.api = new KioskApi({
      basePath
    });
  }

  public async listKiosk(storeid: string): Promise<Station[]> {
    const r = await this.api.listKiosk(storeid);
    return r.data;
  }

  public async loadKiosk(
    storeid: string,
    kioskid: string
  ): Promise<KioskOrderingStore> {
    const r = await this.api.loadKiosk(storeid, kioskid);
    return r.data;
  }

  public async submitOrder(
    storeid: string,
    main: string,
    type: string,
    order: OnlineOrder,
    ccdevice: string,
    ignorePayment: boolean,
    printer?: string
  ): Promise<ResultResponse> {
    const url = `${main}/store/${storeid}/order/pay-instore`;
    order.type = 'order';
    const data = {
      pax_device_id: ccdevice,
      ignore_Payment: ignorePayment,
      printer_id: printer,
      order,
      type
    };
    return (await axios.post<ResultResponse>(url, data)).data;
  }
}
